<template>
    <a-card class="list-of-sessions-wrap">
        <h2>
            List of sessions
            <div class="border"></div>
        </h2>
        <div class="form">
            <p>A list of already existing/made agenda sessions.</p>
            <div class="buttons">
                <div class="timezone">
                    {{ $t('adminAgenda.sessionTimezone') }}
                    <a-select
                        :value="selectedTimezoneOffset"
                        style="width: 254px;"
                        disabled
                        @change="$emit('change-timezone', $event)"
                    >
                        <a-select-option v-for="(tmz, index) in timezones"
                            :key="index"
                            :value="tmz.value"
                        >
                            {{ tmz.label }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="upload-wrap">
                    <a-button
                        v-if="pdf"
                        class="button"
                        icon="upload"
                        ghost
                        style="width: auto; color: #262626; border: 1px solid #D9D9D9;"
                        @click="onPdfUpload"
                    >
                        Upload Sessions as PDF
                    </a-button>
                    <a-upload
                        :fileList="fileList"
                        @change="onPdfSelect"
                    >
                        <a-button
                            class="button"
                            ghost
                            style="width: auto; color: #262626; border: 1px solid #D9D9D9; margin-left: 10px;"
                        >
                            Browse PDF file
                        </a-button>
                    </a-upload>
                </div>
            </div>
            <div class="filters">
                <div class="left">
                    <a-date-picker
                        style="width: 120px;"
                        v-model="query.selectedDay"
                    ></a-date-picker>
                    <a-select
                        v-model="query.selectedLocation"
                        style="width: 120px;"
                    >
                        <a-select-option selected :value="0">All locations</a-select-option>
                        <a-select-option v-for="loc in locations"
                            :key="`loc${loc.loc_id}`"
                            :value="loc.loc_id"
                        >
                            {{ loc.name }}
                        </a-select-option>
                    </a-select>
                    <a-select
                        v-model="query.selectedUser"
                        style="width: 120px;"
                    >
                        <a-select-option :value="0">All Speakers</a-select-option>
                        <a-select-option v-for="user in users"
                            :key="user.usr_id"
                            :value="user.usr_id"
                        >
                            {{ getUserFullName(user) }}
                        </a-select-option>
                    </a-select>
                    <a-select
                        v-model="selectedBulkAction"
                        style="width: 120px;"
                    >
                        <a-select-option selected :value="0">Bulk actions</a-select-option>
                        <a-select-option v-for="action in bulkActions"
                            :key="action.id"
                            :value="action.name"
                        >
                            {{ action.name }}
                        </a-select-option>
                    </a-select>
                    <a-button
                        style="margin-left: -16px;"
                        @click="emitBulkAction"
                    >
                        Apply
                    </a-button>
                    <a-input-search
                        placeholder="Search"
                        enter-button
                        :loading="false"
                        style="width: 254px; border-radius: 10px;"
                        @search="$emit('get-agendas', { search: $event })"
                    />
                </div>
                <div class="right">
                    <span>Filter by tag</span>
                    <a-select
                        v-model="query.selectedTags"
                        mode="multiple"
                        style="width: 200px"
                        :size="'default'"
                        placeholder="Select tags"
                    >
                        <a-select-option
                            v-for="tag in tags"
                            :key="'tag' + tag.tag_id"
                            :value="tag.tag_name"
                        >
                            {{ tag.tag_name }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="table">
                <AgendaListOfSessionsTable
                    v-if="agendas.length > 0"
                    :agendas="agendas"
                    @clone-agenda="$emit('clone-agenda', $event)"
                    @set-current-agenda="$emit('set-current-agenda', $event)"
                    @confirm-delete="$emit('confirm-delete', $event)"
                    @set-selected-agendas="$emit('set-selected-agendas', $event)"
                />
            </div>
        </div>
    </a-card>
</template>

<script>
import timezones from './timezones';
import AgendaListOfSessionsTable from './AgendaListOfSessionsTable.vue';
import bulkActions from './agendaBulkActions';
import moment from 'moment';
export default {
    components: {
        AgendaListOfSessionsTable,
    },
    props: {
        agendas: {
            type: Array,
        },
        locations: {
            type: Array,
        },
        // types: {
        //     type: Array,
        // },
        users: {
            type: Array,
        },
        // companies: {
        //     type: Array,
        // },
        tags: {
            type: Array,
        },
        selectedTimezoneOffset: {
            type: Number
        },
    },
    data () {
        return {
            // initial values are 0 because ant components don't work with nulls
            query: {
                selectedDay: null,
                selectedLocation: 0,
                selectedUser: 0,
                selectedTags: [],
            },
            selectedBulkAction: 0,
            fileList: [],
            pdf: null,
        };
    },
    computed: {
        timezones () {
            return timezones;
        },
        bulkActions () {
            return bulkActions;
        },
    },
    watch: {
        query: {
            deep: true,
            handler () {
                this.applyFilters();
            },
        },
    },
    methods: {
        applyFilters () {
            const params = {};
            if (this.query.selectedLocation !== 0) params.loc = this.query.selectedLocation;
            if (this.query.selectedTags.length > 0) params.tags = this.query.selectedTags;
            if (this.query.selectedUser !== 0) params.speaker = this.query.selectedUser;
            if (this.query.selectedDay) params.day = moment(this.query.selectedDay).format('YYYY-MM-DD');

            this.$emit('get-agendas', params);
        },
        emitBulkAction () {
            if (this.selectedBulkAction) {
                this.$emit('bulk-action', this.selectedBulkAction);
            }
        },
        getUserFullName (user) {
            return `${user.usr_firstname} ${user.usr_lastname}`;
        },
        onPdfSelect (info) {
            // info obj provides hooks where we can handle statuses (more clarification on ant design docs page)
            // e.g. info.file.status === 'done' { *do something* }
            // e.g. info.file.status === 'error' { *handle error* }
            // NOTE: Ant upload seems to work differently for localhost, so we will never have status 'done'

            this.fileList = [info.file]; // this prevents the upload to be multiple
            this.pdf = info.file.originFileObj;

            if (info.file.status === 'removed') {
                this.fileList = [];
                this.pdf = null;
            }
        },
        onPdfUpload () {
            this.$emit('upload-pdf', this.pdf);
            this.fileList = [];
            this.pdf = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.list-of-sessions-wrap {
    * {
        font-family: 'Roboto';
    }
    .form {
        .buttons {
            display: flex;
            justify-content: space-between;
            .timezone {
                display: flex;
                flex-direction: column;
                color: #262626;
                gap: 3px 0;
            }
            .upload-wrap {
                display: flex;
            }
        }
        .filters {
            display: flex;
            justify-content: space-between;
            margin: 26px 0;
            .left {
                display: flex;
                gap: 0 24px;
            }
            .right {
                span {
                    margin-right: 15px;
                    font-weight: 600;
                    color: #001529;
                }
            }
        }
    }
    .button {
        display: flex;
        align-items: center;
        padding: 8px 16px;

        width: 141px;
        height: 40px;

        background: #2295D6;
        border-radius: 2px;
    }
    p {
        color: #001529;
        max-width: 876px;
    }
    h2 {
        position: relative;
        height: 50px;
        font-weight: 600;
        .border {
            $padding: 24px;
            background: #e8e8e8;
            height: 1px;
            width: calc(100% + #{$padding} * 2);
            left: calc(0px - #{$padding});
            position: absolute;
            bottom: 0;
        }
    }
}
</style>
<style lang="scss">
.list-of-sessions-wrap {
    .form {
        .filters {
            .left {
                input {
                    border-radius: 3px;
                }
                .ant-btn {
                    background: #fff;
                    border: 1px solid #DFE1E6;
                }
                .ant-btn-primary {
                    box-shadow: none;
                }
                i {
                    width: 15px;
                    color: #001529;
                }
            }
        }
    }
}
</style>